import { render } from "./KycDropdown.vue?vue&type=template&id=16904942&scoped=true"
import script from "./KycDropdown.vue?vue&type=script&lang=js"
export * from "./KycDropdown.vue?vue&type=script&lang=js"

import "./KycDropdown.vue?vue&type=style&index=0&id=16904942&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16904942"]])

export default __exports__